import { routes } from "consts";
import React from "react";
import { ChangelogArticle, ChangelogBody, LinkTo } from "../components";

export const Article20240910 = (): JSX.Element | null => {
  return (
    <ChangelogArticle date="10 Wrzesień, 2024" header="Nowa wersja 1.1.0" labels={["feature"]}>
      <ChangelogBody title="1. Ekran Temat - Wystąpienia w kursach">
        Po wejściu w ekran <LinkTo to={routes.TOPICS_EDIT("3")}>edycji pojedynczego tematu</LinkTo>, widzimy nową
        zakładkę "Wystąpienia w kursach".
        <br />W tej zakładce możemy zobaczyć w jakich harmonogramach kursów występuje dany temat.
      </ChangelogBody>

      <ChangelogBody title="2. Ekran Grupa Tematów - Wystąpienia w kursach">
        Po wejściu w ekran <LinkTo to={routes.TOPICS_GROUPS_EDIT("1")}>edycji grupy tematów</LinkTo>, widzimy nową
        zakładkę "Wystąpienia w kursach".
        <br />W tej zakładce możemy zobaczyć w jakich harmonogramach kursów występuje dana grupa tematów.
      </ChangelogBody>

      <ChangelogBody title="3. Tworzenie ankiety końcowej kursu">
        Na ekranie <LinkTo to={routes.SURVEYS_ADD}>tworzenia nowej ankiety</LinkTo> dodano możliwość określenia ankiety
        jako ankieta końcowa kursu. Ankiety tak oznaczone będą dostępne do wyboru na ekranie edycji kursu w{" "}
        <LinkTo to={routes.COURSES_EDIT_NESTED.SURVEYS("1")}>zakładce Ankiety.</LinkTo>
      </ChangelogBody>

      <ChangelogBody title="4. Bilans ogólny kursu - pobieranie faktur">
        Na ekranie <LinkTo to={routes.COURSES_MANAGE_NESTED.FINANCES("1")}>bilansu ogólnego kursu</LinkTo> dodano
        możliwość pobierania faktur, jeśli takowa została dołączona do kosztu/przychodu.
      </ChangelogBody>

      <ChangelogBody title="5. Podgląd wiadomości email">
        Na ekranie <LinkTo to={routes.EMAILS}>listy wiadomości email</LinkTo> dodano możliwość podglądu faktycznego
        widoku wiadomości. Po kliknięciu na wybrany wiersz, pojawi się okno z podglądem wiadomości.
      </ChangelogBody>
    </ChangelogArticle>
  );
};
